import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const OutSvg = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.2931 15.292L18.5861 12.999H10.0001V10.999H18.5861L16.2931 8.70599L17.7071 7.29199L22.4141 11.999L17.7071 16.706L16.2931 15.292Z" fill="currentColor" />
    <path
      d="M4 2.99902H6C6.53043 2.99902 7.03914 3.20974 7.41421 3.58481C7.78929 3.95988 8 4.46859 8 4.99902V18.999C8 19.5295 7.78929 20.0382
      7.41421 20.4132C7.03914 20.7883 6.53043 20.999 6 20.999H4C3.46957 20.999 2.96086 20.7883 2.58579 20.4132C2.21071 20.0382 2 19.5295 2
      18.999V4.99902C2 3.89602 2.896 2.99902 4 2.99902ZM4.003 18.999H6V4.99902H4L4.003 18.999Z"
      fill="currentColor"
    />
  </svg>
);

const Out = (props: IIconProps) => <Icon component={OutSvg} {...props} />;

export default Out;
